import {
  LayoutTemplateContainer,
  LayoutTemplateTitle,
  LayoutTemplateController,
} from '../../_layouts/LayoutsEditTemplate';
import { ChevronLeft } from 'lucide-react';
import { Button } from '@/components/atoms/NewPcButton';

interface SelectedTemplateProps {
  title: string;
  content: string;
  onBack: () => void;
  onSelect: () => void;
}

export const SelectedTemplate = ({ title, content, onBack, onSelect }: SelectedTemplateProps) => {
  return (
    <LayoutTemplateContainer>
      <div className="flex flex-1 flex-col gap-[12px]">
        <Header onBack={onBack} />
        <Body title={title} content={content} />
      </div>
      <Controller onBack={onBack} onSelect={onSelect} />
    </LayoutTemplateContainer>
  );
};

const Header = ({ onBack }: { onBack: () => void }) => (
  <LayoutTemplateTitle>
    <button className="flex items-center" onClick={onBack} aria-label="뒤로가기">
      <ChevronLeft className="h-6 w-6" />
      <div className="">템플릿 선택</div>
    </button>
  </LayoutTemplateTitle>
);

const Body = ({ title, content }: Pick<SelectedTemplateProps, 'title' | 'content'>) => (
  <div className="flex flex-1 flex-col gap-[8px]">
    <div className="border-b border-gr-200 pb-[8px] pt-[10px] text-gr-800 Body2M16">{title}</div>
    <div className="text-gr-700 Body5M14">{content}</div>
  </div>
);

const Controller = ({ onBack, onSelect }: Pick<SelectedTemplateProps, 'onBack' | 'onSelect'>) => {
  return (
    <LayoutTemplateController>
      <Button variant="secondary" className="h-[44px] flex-1 Body5M14" onClick={onBack}>
        취소
      </Button>
      <Button variant="solid" className="h-[44px] flex-1 Body5M14" onClick={onSelect}>
        답변 선택
      </Button>
    </LayoutTemplateController>
  );
};
